<template>
    <AppLayout :loading="processing">
        <div class="container p-4 mx-auto md:px-1 md:py-4">
            <div class="min-h-screen bg-gray-50 p-6">
                <div class="max-w-4xl mx-auto bg-white rounded-2xl shadow p-6">
                    <div class="pb-4">
                        <AppLogo />
                    </div>
                    <h1 class="text-2xl font-bold text-gray-800 mb-2">Complete Your KYC</h1>
                    <p class="text-sm text-gray-500 mb-6">Please fill in the required details in each step.</p>
                    <KycWizard
                        :kyc="kycData"
                        @completed="handleCompletion"
                        @processing="processing = $event"
                    />
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
    import AppLogo from '@/Components/AppLogo';
    import KycWizard from '@/Components/Kyc/KYCWizard.vue';

    export default {
        name: 'KycForm',
        components: {
            AppLogo,
            KycWizard,
        },
        props: ['kyc'],
        data() {
            return {
                processing: false, // 🔹 Track loading from child
            };
        },
        computed: {
            kycData() {
                return this.kyc || {};
            },
        },
        methods: {
            handleCompletion(data) {
                console.log('KYC submitted:', data);
                // this.$inertia.post('/kyc/submit', data);
            },
        },
    };
</script>

<style scoped>
    /* You can optionally add scoped styles here */
</style>
